/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';

import { InfiniteScrollComponent } from '@playbookux/playbook-web-core';
import participantsSource from '../../../../../core/constants/participantsSource';

import {
  Table,
  Row,
  HeaderColumn,
  Text,
  Header,
  Column,
  Body,
  Container,
  Link,
  ProjectNameWrapper,
  StyledText,
} from './styles';

const CustomTable = (props) => {
  const {
    usageLogs,
    fetchMore,
    hasMore,
    admin,
    refetch,
    toggleHideUsageLog,
  } = props;

  const participantsSourceText = (sourceParticipant) => {
    if (participantsSource.PLAYBOOK === sourceParticipant) {
      return 'PlaybookUX';
    }

    return 'Your own participants';
  };

  const handleToggleHideUsageLog = (id) => {
    toggleHideUsageLog({
      variables: {
        id,
      },
    }).then(() => {
      refetch();
    });
  };

  const getPrice = (price) => {
    const cost = price.toString();

    if (price > 0) {
      return `+ $${cost}`;
    }
    if (price < 0) {
      return `- $${cost.substr(1, cost.length - 1)}`;
    }
    return '$0';
  };

  return (

    <Container>
      <InfiniteScrollComponent
        useWindow
        hasMore={hasMore}
        onLoadMore={fetchMore}
      >
        <Table basic="very">
          <Header>
            <Row>
              <HeaderColumn>
                <Text.Bold>Date</Text.Bold>
              </HeaderColumn>
              <HeaderColumn>
                <Text.Bold>Project name</Text.Bold>
              </HeaderColumn>
              <HeaderColumn>
                <Text.Bold>Created by</Text.Bold>
              </HeaderColumn>
              <HeaderColumn>
                <Text.Bold>Project type</Text.Bold>
              </HeaderColumn>
              <HeaderColumn>
                <Text.Bold>Participant type</Text.Bold>
              </HeaderColumn>
              <HeaderColumn>
                <Text.Bold>Cost (USD)</Text.Bold>
              </HeaderColumn>
              <HeaderColumn>
                <Text.Bold>Reason</Text.Bold>
              </HeaderColumn>
              {admin && (
                <HeaderColumn>
                  <Text.Bold>Hide log</Text.Bold>
                </HeaderColumn>
              )}
            </Row>
          </Header>

          <Body>
            {!_.isEmpty(usageLogs) && _.orderBy(usageLogs, ['createdAt'], ['desc']).map((usage) => {
              const projectStatus = _.get(usage, 'project.status', '');
              if (projectStatus !== 'draft') {
                const firstName = _.get(usage, 'project.createdBy.profile.firstName', '');
                const lastName = _.get(usage, 'project.createdBy.profile.lastName', '');
                const price = getPrice(usage.price);
                const isHidden = usage.hidden;
                const showUsage = (!isHidden || admin);
                const isDeleted = usage.project.deletedAt;
                const isMoved = usage.project.movedTo;

                const testType = usage?.project?.testType === 'moderated'
                  ? `${_.startCase(usage.project.testType)} (${usage?.project?.sessionDuration} Min)`
                  : _.startCase(usage.project.testType);

                return (
                  <Row key={usage.id}>
                    {showUsage && (
                      <Column>
                        <Text>{moment(usage.createdAt).format('LL')}</Text>
                      </Column>
                    )}

                    {showUsage && (
                      <Column>
                        <ProjectNameWrapper>
                          <StyledText>{usage.project.name}</StyledText>
                          {isDeleted && (
                            <StyledText style={{ color: '#DC651E' }}>[Deleted]</StyledText>
                          )}
                          {isMoved && (
                            <StyledText style={{ color: '#DC651E' }}>
                              [Moved to
                              {' '}
                              {usage.project.movedTo}
                              ]
                            </StyledText>
                          )}
                        </ProjectNameWrapper>
                      </Column>
                    )}

                    {showUsage && (
                      <Column>
                        <Text>{`${firstName} ${lastName}`}</Text>
                      </Column>
                    )}

                    {showUsage && (
                      <Column>
                        <Text>{testType}</Text>
                      </Column>
                    )}

                    {showUsage && (
                      <Column>
                        <Text>{participantsSourceText(usage.project.participantsSource)}</Text>
                      </Column>
                    )}

                    {showUsage && (
                      <Column>
                        <Text>{price}</Text>
                      </Column>
                    )}

                    {showUsage && (
                      <Column>
                        <Text>{usage.reason}</Text>
                      </Column>
                    )}

                    {showUsage && admin && (
                      <Column>
                        <Link onClick={() => handleToggleHideUsageLog(usage.id)} color="#ff0000">{usage.hidden ? 'Unhide' : 'Hide'}</Link>
                      </Column>
                    )}

                  </Row>
                );
              }
            })}
          </Body>
        </Table>
      </InfiniteScrollComponent>
    </Container>
  );
};

CustomTable.defaultProps = {
  refetch: () => {},
  toggleHideUsageLog: () => {},
};

CustomTable.propTypes = {
  usageLogs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      createdAt: PropTypes.string,
      createdBy: PropTypes.shape({
        id: PropTypes.string,
        profile: PropTypes.shape({
          id: PropTypes.string,
          firstName: PropTypes.string,
          lastName: PropTypes.string,
        }),
      }),
      testType: PropTypes.string,
      reason: PropTypes.string,
      participantsSource: PropTypes.string,
    }),
  ).isRequired,
  fetchMore: PropTypes.func.isRequired,
  refetch: PropTypes.func,
  hasMore: PropTypes.bool.isRequired,
  toggleHideUsageLog: PropTypes.func,
  admin: PropTypes.bool.isRequired,
};

export default CustomTable;
